import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

/**
 * Small circular pencil control for editing a label (e.g. menu category title, bill name).
 * Filled light grey circle with a dark pencil (not the outlined “basic” variant).
 */
export default function InlineEditIconButton({
  ariaLabel = 'Editar',
  as,
  to,
  href,
  onClick,
  style,
  ...rest
}) {
  const mergedStyle = {
    marginLeft: '8px',
    flexShrink: 0,
    boxShadow: 'none',
    backgroundColor: '#e5e5e5',
    border: 'none',
    color: '#4a4a4a',
    ...style,
  };

  return (
    <Button
      type={as || to || href ? undefined : 'button'}
      size="tiny"
      icon
      circular
      as={as}
      to={to}
      href={href}
      onClick={onClick}
      aria-label={ariaLabel}
      style={mergedStyle}
      {...rest}
    >
      <Icon name="pencil" style={{ color: '#4a4a4a' }} />
    </Button>
  );
}
